import { compose } from 'redux'
import { connect } from 'react-redux'
import {  firebaseConnect } from 'react-redux-firebase'
import { withContext, getContext } from 'recompose'
import PropTypes from 'prop-types'

import Login from '../components/Login'
import { loadAssessmentsData, invalidateAssessment } from '../../assessments/actions'
import { invalidateActivity } from '../../activities/actions'
//({ firebase: { auth,profile } }) => ({ auth,profile })
function mapStateToProps(state) {
  const { firebase: { auth, profile }, errorMessage 
  } = state

  //console.log('login')
  return { auth, profile , errorMessage
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {firebase} = ownProps
  return {
    //loadData: (e) => ownProps.firebase.login({ email: ownProps.updatedUsername, password: ownProps.updatedPassword }),
    loadData: (user) =>  { 
      dispatch({type: 'ERROR' })
      dispatch(loadAssessmentsData(user,ownProps.store)) 
    },
    logout: (e) => {
      dispatch(invalidateActivity())
      dispatch(invalidateAssessment())
      firebase.logout()
    },
    showErrorMessage: (message) => {dispatch({type: 'ERROR', id: 'login', message })}


  }
}

const withStore = compose(
  withContext({ store: PropTypes.object }, () => {}),
  getContext({ store: PropTypes.object }),
)

export default compose(
  //withFirebase,
  
  firebaseConnect(),
  withStore,
  connect(mapStateToProps, mapDispatchToProps)
)(Login)



// WEBPACK FOOTER //
// ./src/login/containers/Login.js